import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  useReactTable
} from "@tanstack/react-table";

interface UniversalSubTableProps {
  tableData?: unknown[];
  tableColumns: ColumnDef<unknown, any>[];
}

export const UniversalSubTable = ({
  tableData,
  tableColumns
}: UniversalSubTableProps) => {
  const table = useReactTable({
    data: tableData || [],
    columns: tableColumns,
    getCoreRowModel: getCoreRowModel(),
    columnResizeMode: "onChange" // Ensure column sizes update on change
  });

  return (
    <div className="relative w-full overflow-auto pb-4">
      <table className="w-full table-fixed">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id} className="h-11 text-left">
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    className="first:text-sm text-xs font-medium first:text-content-1000 text-content-300 border-b border-alpha-40"
                    style={{ width: header.getSize() }}
                  >
                    {header.isPlaceholder ? null : (
                      <p>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </p>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>

        <tbody className="bg-background-800">
          {table.getRowModel().rows.map((row) => {
            return (
              <tr className="h-12" key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td
                      key={cell.id}
                      className="first:pl-2 last:pr-2 text-content-400"
                      style={{ width: cell.column.getSize() }}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
